import difference from 'lodash/difference';
import has from 'lodash/has';
import keyBy from 'lodash/keyBy';

import type { Application } from '@src/@types/app';
import type { List } from '@src/@types/microcredits';
import { FILTERS_NAMES } from '@src/constants/filters';
import type { ListKeys } from '@src/constants/microcredits';
import { getUserPhoneForChecker } from '@src/helpers/getUserPhoneForChecker';
import { queryStringToArray } from '@src/helpers/strings/queryArray';
import { CookieKey } from '@src/modules/cookie';
import { fetchOffers } from '@src/reducers/microcredits';
import { getCookieFromServerOrClient } from '@src/utils/getCookieFromServerOrClient';
import { CHECKER_QUERY, NOT_DISPLAY_VALUE } from 'pageModules/SpecialPage/ui/SpecialPage.config';

import { getPageListQuery } from './getPageListQuery';

interface IListParams {
  key: ListKeys;
  defaultFiltersMode: string;
}

// query параметр который не отправляется на бэк
const TOP_MFO_QUERY_PARAM = 'topMFO';
const CRM_PAGE_QUERY_PARAM = 'landing_type';
const PAGE_CONTENT_QUERY_PARAM = 'cnt';
const PAGE_OFF_QUERY_PARAM = 'off';

export const getSpecialPageListData = async (ctx: Application.ReduxNextPageContext, listParams: IListParams) => {
  const {
    store: { dispatch },
  } = ctx;
  const { key, defaultFiltersMode } = listParams;

  const query = getPageListQuery({ ctx, defaultFiltersMode });
  const topMFOQueryParam = ctx.query[TOP_MFO_QUERY_PARAM];

  if (Number(topMFOQueryParam) >= 1) {
    query.limit = topMFOQueryParam;
  }

  const isCRMSpecial = has(ctx.query, CRM_PAGE_QUERY_PARAM);
  const clientId = getCookieFromServerOrClient(ctx, CookieKey._ym_uid);

  /**
   * @todo: Кверик cnt используется для передачи id оферов которые нужно отобразить на странице
   * @link https://sravni-corp.atlassian.net/browse/MFO-1642
   */

  const customOfferIds = difference(
    queryStringToArray(ctx.query[PAGE_CONTENT_QUERY_PARAM]),
    queryStringToArray(ctx.query[PAGE_OFF_QUERY_PARAM]),
  );

  const isCheckerEnabled = ctx.query?.[CHECKER_QUERY] !== NOT_DISPLAY_VALUE;

  const filterParams = {
    [FILTERS_NAMES.IGNORE_FILTERS]: true,
    [FILTERS_NAMES.LOCATION]: ctx.params.locationRoute,
    [FILTERS_NAMES.METADATA]: true,
    ...(isCheckerEnabled ? getUserPhoneForChecker(ctx) : {}),
    [FILTERS_NAMES.ROUTE]: { asPath: ctx.asPath ?? '', query: ctx.query ?? {} },
    ...(!isCRMSpecial &&
      Boolean(clientId) && {
        [FILTERS_NAMES.CLIENT_ID]: clientId,
      }),

    ...(customOfferIds.length && {
      ids: customOfferIds,
    }),
  };

  await dispatch(
    fetchOffers({
      query,
      params: filterParams,
      key,
      formatOffers: sortItemsByIdsPosition(customOfferIds),
    }),
  );
};

function sortItemsByIdsPosition(customOfferIds: string[]) {
  return (items: List.IMicrocredit[]) => {
    if (!customOfferIds?.length) return items;

    const itemsById = keyBy(items, '_id');
    return customOfferIds.map((id) => itemsById[id]).filter(Boolean);
  };
}
